export const MEMBER_CLINICAL_DATA_KEY = 'member-clinical-data';
export const ENROLLMENT_HISTORY_KEY = 'member-enrollment-history';
export const PORTAL_LINK_KEY = 'member-portal-link';
export const DRCHRONO_TASKS_KEY = 'member-drchrono-tasks';
export const DRCHRONO_TASK_STATUSES_KEY = 'drchrono-task-statuses';
